const actions = {
    PURCHASE_DASHBOARD_START: 'PURCHASE_DASHBOARD_START',
    PURCHASE_DASHBOARD_SUCCESS: 'PURCHASE_DASHBOARD_SUCCESS',
    PURCHASE_DASHBOARD_FAILURE: 'PURCHASE_DASHBOARD_FAILURE',
};

export default actions;